"use client";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";

import CustomButton from "../../../components/custom/CustomButton";
import { BOM } from "../../../services/definedMethod";
import { labelConfig, staticConfig } from "../serviceProvider.config";

const { Text, Title } = Typography;

const ContactInformationForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    identifactionTypeData,
    legalOption,
    countryData,
    idType,
    disabledAfterCurrentDate,
    disableDaysBeforeToday,
    isLoading,
    formData,
    stateProvinceIdData,
    countryIdData,
    addressTypeIdData,
    isModalOpen,
    setIsModalOpen,
    setAddressList,
    addressList,
    handleAddressDelete,
    isCreateScreen,
  } = props;

  return (
    <div>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
        Contact Information
      </h1>
      <p
        style={{
          color: "#6b7280",
          fontWeight: "400",
          marginBottom: "24px",
          marginTop: 0,
        }}
      >
        Add description text to note for users
      </p>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.email}
              name="emailAddress"
              rules={[
                {
                  required: true,
                  type: "email",
                },
              ]}
            >
              <Input
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(labelConfig.email)}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.mobileNumber}
              name="mobileNo"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.mobileNumber),
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (value?.length !== 11) {
                      return Promise.reject(
                        new Error("Mobile number must be exactly 11 digits"),
                      );
                    }
                    if (!/^[0-9]{11}$/.test(value)) {
                      return Promise.reject(
                        new Error("Mobile number must contain only numbers"),
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(labelConfig.mobileNumber)}
                // style={styles.ofInputFieldNumber}
              />
            </Form.Item>
          </Col>
          {!(legalOption === 2) && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.nationality} name="nationality">
                  <Select
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.nationality,
                      "select",
                    )}
                    options={countryData}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.identifactionType}
                  name="idTypeId"
                >
                  <Select
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.identifactionType,
                      "select",
                    )}
                    options={identifactionTypeData}
                    allowClear
                  />
                </Form.Item>
              </Col>
            </>
          )}
          {idType && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.identifactionNo}
                  name="idNo"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.identifactionNo),
                    },
                  ]}
                >
                  <Input
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.identifactionNo,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.issuingDate}
                  name="idIssuingDate"
                  rules={[
                    {
                      required: idType === 2 ? false : true,
                      message: BOM.CheckReqFld(labelConfig.issuingDate),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.issuingDate,
                      "select",
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.expiryDate}
                  name="passExpDate"
                  rules={[
                    {
                      required: idType === 2 ? false : true,
                      message: BOM.CheckReqFld(labelConfig.expiryDate),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={disableDaysBeforeToday}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.expiryDate,
                      "select",
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
        {isCreateScreen && (
          <Row>
            <div
              style={{
                width: "100%",
                padding: "16px",
              }}
            >
              <Spin spinning={isLoading} tip="Loading..." size="large">
                <Divider orientation="left" orientationMargin="0"></Divider>

                {BOM.HasPermission("READ_ADDRESS") && (
                  <AddressModal
                    formData={formData}
                    stateProvinceIdData={stateProvinceIdData}
                    countryIdData={countryIdData}
                    addressTypeIdData={addressTypeIdData}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    setAddressList={setAddressList}
                    addressList={addressList}
                  />
                )}

                {addressList?.length > 0 && (
                  <Space
                    direction="vertical"
                    style={{ width: "100%" }}
                    size={16}
                  >
                    {addressList.map((address) => (
                      <Card
                        key={address.id}
                        bodyStyle={{ padding: "16px 24px" }}
                        style={{
                          borderRadius: "16px",
                          border: "1px solid #E2E8F0",
                          backgroundColor: "#F8FAFC",
                        }}
                      >
                        <Row justify="space-between" align="middle">
                          <Col>
                            <Text
                              strong
                              style={{
                                display: "block",
                                fontSize: "16px",
                                color: "#1A202C",
                                marginBottom: "4px",
                              }}
                            >
                              {address.title}
                            </Text>
                            <Text type="secondary" style={{ color: "#718096" }}>
                              {address.description}
                            </Text>
                          </Col>
                          <Col>
                            <Button
                              type="text"
                              danger
                              icon={<DeleteOutlined />}
                              onClick={() => handleAddressDelete(address.id)}
                              style={{
                                fontWeight: "600",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              Remove
                            </Button>
                          </Col>
                        </Row>
                      </Card>
                    ))}
                  </Space>
                )}
              </Spin>
            </div>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default ContactInformationForm;

const AddressModal = (props) => {
  const {
    stateProvinceIdData,
    formData,
    countryIdData,
    addressTypeIdData,
    isModalOpen,
    setIsModalOpen,
    setAddressList,
    addressList,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleAddressSave = (formValues) => {
    const addressType = addressTypeIdData?.find(
      (item) => item.value === formValues.addressTypeId,
    );
    const stateProvince = stateProvinceIdData?.find(
      (item) => item.value === formValues.stateProvinceId,
    );
    const country = countryIdData?.find(
      (item) => item.value === formValues.countryId,
    );

    const newAddress = {
      id: formValues?.addressTypeId,
      title: addressType?.label,
      description: `${formValues?.addressLine1}, ${formValues?.city}, ${stateProvince?.label}, ${country?.label}, ${formValues?.postalCode}`,
      addressLine1: formValues?.addressLine1,
      addressLine2: formValues?.addressLine2,
      addressTypeId: formValues?.addressTypeId,
      city: formValues?.city,
      countryId: formValues?.countryId,
      isActive: formValues?.isActive,
      postalCode: formValues?.postalCode,
      stateProvinceId: formValues?.stateProvinceId,
    };
    setAddressList([...addressList, newAddress]);
    useForm.resetFields();
  };

  return (
    <div style={{ padding: "0px", width: "100%" }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Title level={4} style={{ margin: 0, color: "#2D3748" }}>
          Address Information
        </Title>
        <Button
          icon={<PlusOutlined />}
          onClick={showModal}
          style={{
            borderRadius: "8px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
          }}
        >
          Add address
        </Button>
      </Row>

      <Modal
        title="Address Information Setup"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
      >
        <Form
          form={useForm}
          layout="vertical"
          onFinish={handleAddressSave}
          name="address-info"
        >
          <Row>
            <Divider />

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressTypeId}
                  name={"addressTypeId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressTypeId),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressTypeId,
                      "select",
                    )}
                    options={addressTypeIdData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressOne}
                  name={"addressLine1"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressOne),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressOne,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressTwo}
                  name={"addressLine2"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(
                  //       labelConfig.addressTwo
                  //     ),
                  //   },
                  // ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressTwo,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.city}
                  name={"city"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.city),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.city)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.country}
                  name={"countryId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.country),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.country,
                      "select",
                    )}
                    options={countryIdData}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.stateProvince}
                  name={"stateProvinceId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.stateProvince),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.stateProvince,
                      "select",
                    )}
                    options={stateProvinceIdData}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.postalCode}
                  name={"postalCode"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(
                  //       labelConfig.postalCode
                  //     ),
                  //   },
                  // ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.postalCode,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressStatus}
                  name={"isActive"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressStatus),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.addressStatus}`,
                      "select",
                    )}
                    options={staticConfig.statusData}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>
          </Row>

          <Row>
            <Divider />
            <CustomButton
              content="Save"
              style={{
                backgroundColor: "#BA24D5",
                color: "white",
                border: "1px solid #BA24D5",
                borderRadius: 8,
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                fontSize: "16px",
                fontWeight: "600",
                width: "10%",
                marginLeft: "auto",
              }}
              htmlType="submit"
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />

            <CustomButton
              content="Cancel"
              style={{
                backgroundColor: "#BA24D5",
                color: "white",
                border: "1px solid #BA24D5",
                borderRadius: 8,
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                fontSize: "16px",
                fontWeight: "600",
                marginLeft: "1%",
                width: "10%",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
